/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_Verified_BusinessInputs */

const en_badge_verified_business = /** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Business`)
};

const es_badge_verified_business = /** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negocio Verificado`)
};

const fr_badge_verified_business = /** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise Vérifiée`)
};

const de_badge_verified_business = /** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziertes Unternehmen`)
};

const id_badge_verified_business = /** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisnis Terverifikasi`)
};

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const ja_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const zh_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const ar_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const it_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const ru_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const pt_badge_verified_business = en_badge_verified_business;

/** @type {(inputs: Badge_Verified_BusinessInputs) => LocalizedString} */
const ko_badge_verified_business = en_badge_verified_business;

/**
* | output |
* | --- |
* | "Verified Business" |
*
* @param {Badge_Verified_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_verified_business = /** @type {((inputs?: Badge_Verified_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Verified_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_verified_business(inputs)
	if (locale === "es") return es_badge_verified_business(inputs)
	if (locale === "fr") return fr_badge_verified_business(inputs)
	if (locale === "de") return de_badge_verified_business(inputs)
	if (locale === "ja") return ja_badge_verified_business(inputs)
	if (locale === "zh") return zh_badge_verified_business(inputs)
	if (locale === "ar") return ar_badge_verified_business(inputs)
	if (locale === "id") return id_badge_verified_business(inputs)
	if (locale === "it") return it_badge_verified_business(inputs)
	if (locale === "ru") return ru_badge_verified_business(inputs)
	if (locale === "pt") return pt_badge_verified_business(inputs)
	return ko_badge_verified_business(inputs)
});